module.exports = "/assets/images/laughing.png";